import { MapContainer, TileLayer, Marker, GeoJSON } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect, useState, useRef } from "react";
import L from "leaflet";

function MapPreview({
  lat = "3",
  lng = "3",
  full = false, // Detailed map view aka full view
  cadastreId = "3278004",
}) {
  const mapRef = useRef();
  const [geoJson, setGeoJson] = useState(null);

  useEffect(() => {
    async function fetchParcel() {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auctions/cadastre/${cadastreId}`
      );
      const data = await response.json();
      setGeoJson(data);
    }
    if (cadastreId && full) fetchParcel();
  }, [cadastreId]);

  useEffect(() => {
    if (geoJson && geoJson.features?.length && mapRef.current) {
      const layer = L.geoJSON(geoJson);
      const bounds = layer.getBounds();
      if (bounds.isValid()) {
        const calcCenter = bounds.getCenter();

        lat = calcCenter.lat;
        lng = calcCenter.lng;

        // Pan the map immediately
        // mapRef.current.fitBounds(bounds, { padding: [20, 20] });
      }
    }
  }, [geoJson]);

  return (
    <MapContainer
      center={full ? [lat, lng] : [56.95, 24.1]}
      zoom={full ? 12.5 : 5}
      zoomDelta={full ? 2 : 1}
      style={{ height: "100%", width: "100%" }}
      scrollWheelZoom={false}
      dragging={full}
      zoomControl={full}
      doubleClickZoom={full}
      attributionControl={false}
      whenCreated={(mapInstance) => (mapRef.current = mapInstance)}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <Marker position={[lat, lng]} />
      {geoJson && (
        <GeoJSON data={geoJson} style={{ color: "green", weight: 3 }} />
      )}
    </MapContainer>
  );
}

export default MapPreview;
